







































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, performanceServer } from '@/api/installServer';
import AddDialog from '@/views/inspectionContents/unit/addDialog.vue';

@Component({
  components: { AddDialog, CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class InspectionContents extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  // 表单数据对象
  formData: any = {
    assessType: '',
    assessProject: '',
  };
  // table 数据对象
  tableData: any = [];
  assessTypeList: any = []; // 考核类型
  assessProjectList: any = []; // 考核项目

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取分页数据
    this.getPageData();
    this.getDictDataByName('assessType');
    this.getDictDataByName('safeProductionAssessProject');
  }

  // 创建开始点击事件
  createExam(type: any, data?: any) {
    const detailsDialog: any = 'detailsDialog';
    const detailsDialogRef: any = this.$refs[detailsDialog];
    detailsDialogRef.showAddDialog(type, data);
  }

  // 打开删除事件
  deleteAssessStandConfig(id: any) {
    this.$confirm('确认要删除该条数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        performanceServer.deleteAssessStandConfig(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('数据删除成功！');
            this.getListData();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getAssessStandConfig({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        assessType: this.formData.assessType ? this.formData.assessType : null,
        assessProject: this.formData.assessProject ? this.formData.assessProject : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
        // console.log(res);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      assessType: '',
      assessProject: '',
    };
    this.getPageData();
  }

  // 考核类型
  getDictDataByName(name: any) {
    const helpArr: any = [];
    dictServe
      .getDetailsMapByName(name)
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          for (const key in res.data) {
            helpArr.push({
              label: key,
              value: res.data[key],
            });
          }
          if (name === 'assessType') {
            this.assessTypeList = helpArr;
          } else if (name === 'safeProductionAssessProject') {
            this.assessProjectList = helpArr;
          }
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败！');
      });
  }
}
